export default "__VITE_ASSET__$LRu3qiK__"